import React, { useState } from "react";

import { Button, Form, Modal } from "react-bootstrap";

import styles from "./AddEditPseudonymModal.module.scss";

interface AddEditPseudonymModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (pseudonym: string) => Promise<void>;
  onDelete?: () => Promise<void>;
  pseudonym?: string;
  participantName?: string;
  isSubmitting: boolean;
}

const AddEditPseudonymModal: React.FC<AddEditPseudonymModalProps> = ({
  show,
  onClose,
  onSubmit,
  onDelete,
  pseudonym,
  participantName,
  isSubmitting,
}) => {
  const [inputPseudonym, setInputPseudonym] = useState<string | undefined>(pseudonym);

  const handleConfirm = async () => {
    try {
      if (!inputPseudonym) {
        return;
      }
      await onSubmit(inputPseudonym);
      onClose();
    } catch (error) {
      console.error("Error updating pseudonym:", error);
    }
  };

  const handleDelete = async () => {
    if (onDelete) {
      try {
        await onDelete();
        onClose();
      } catch (error) {
        console.error("Error deleting pseudonym:", error);
      }
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered className={styles.modal}>
      <div className={styles.modalContainer}>
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>

        <Modal.Header className={styles.modalHeader}>
          <Modal.Title className={styles.modalTitle}>
            {pseudonym ? "Edit" : "Add"} Pseudonym for {participantName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <Form.Group controlId="pseudonymInput" className={styles.formGroup} style={{ marginBottom: 0 }}>
            <Form.Label className={styles.formLabel}>Pseudonym</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter pseudonym"
              value={inputPseudonym}
              onChange={(e) => setInputPseudonym(e.target.value)}
              className={styles.formControl}
              style={{ boxShadow: "none", border: "1px solid #ccc" }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter} style={{ borderTop: "none" }}>
          <Button variant="primary" onClick={handleConfirm} className={styles.confirmButton} disabled={isSubmitting}>
            Confirm
          </Button>
          {onDelete && (
            <Button variant="link" className={styles.deleteButton} onClick={handleDelete}>
              Delete
            </Button>
          )}
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default AddEditPseudonymModal;
